import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AlertStatusGrid from '../components/alerts/AlertStatusGrid.tsx';
import DashboardLink from '../components/DashboardLink.tsx';

export default function AlertsPage() {
  return (
    <Box sx={{ p: '0 1.5rem 2.5rem', width: '100%', height: '100vh', boxSizing: 'border-box' }}>

      {/* ── Header ── */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3, flexWrap: 'wrap', gap: 2 }}>
        <Typography sx={{
          fontFamily: "'Syne', sans-serif",
          fontSize: 20,
          fontWeight: 600,
          color: '#1D9E75',
        }}>
          Alerts
        </Typography>

        {/* Nav links */}
        <Box sx={{ display: 'flex', gap: 1 }}>
          <DashboardLink title="Alert Rules"      linkto="alert-rules" />
          <DashboardLink title="Manage Contacts"  linkto="alert-contacts" />
        </Box>
      </Box>

      {/* ── Grid panel ── */}
      <Box sx={{ background: 'var(--color-bg-secondary)', borderRadius: 3, p: '1.25rem', height: '75vh' }}>
        <AlertStatusGrid />
      </Box>
    </Box>
  );
}
